/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AwesomeInputs */

const en_awesome = /** @type {(inputs: AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awesome`)
};

const ar_awesome = /** @type {(inputs: AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدهش`)
};

const de_awesome = /** @type {(inputs: AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toll`)
};

const es_awesome = /** @type {(inputs: AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Genial`)
};

const fr_awesome = /** @type {(inputs: AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génial`)
};

const it_awesome = /** @type {(inputs: AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Splendido`)
};

const ja_awesome = /** @type {(inputs: AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`素晴らしい`)
};

const ko_awesome = /** @type {(inputs: AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대단해요`)
};

const pt_br_awesome = /** @type {(inputs: AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incrível`)
};

const ru_awesome = /** @type {(inputs: AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Супер`)
};

const th_awesome = /** @type {(inputs: AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สุดยอด`)
};

const tr_awesome = /** @type {(inputs: AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harika`)
};

const zh_cn_awesome = /** @type {(inputs: AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`太棒了`)
};

const zh_tw_awesome = /** @type {(inputs: AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`太棒了`)
};

/**
* | output |
* | --- |
* | "Awesome" |
*
* @param {AwesomeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const awesome = /** @type {((inputs?: AwesomeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AwesomeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_awesome(inputs)
	if (locale === "ar") return ar_awesome(inputs)
	if (locale === "de") return de_awesome(inputs)
	if (locale === "es") return es_awesome(inputs)
	if (locale === "fr") return fr_awesome(inputs)
	if (locale === "it") return it_awesome(inputs)
	if (locale === "ja") return ja_awesome(inputs)
	if (locale === "ko") return ko_awesome(inputs)
	if (locale === "pt_br") return pt_br_awesome(inputs)
	if (locale === "ru") return ru_awesome(inputs)
	if (locale === "th") return th_awesome(inputs)
	if (locale === "tr") return tr_awesome(inputs)
	if (locale === "zh_cn") return zh_cn_awesome(inputs)
	return zh_tw_awesome(inputs)
});